export default "__VITE_ASSET__BfLiYKve__"